// @ts-expect-error
import { TOKENS_ODEDITOR_CSS_CDN_URL } from '@wix/design-system/dist/esm/CDN_URLS.js'
import React, { FC, useEffect, useState } from 'react'

import { errorMonitor } from '../../../errorMonitor'

type TokenType = 'odeditor'

interface DesignSystemTokensLoaderProps {
  type: TokenType
}

const TOKEN_MAP: Record<TokenType, string> = {
  odeditor: TOKENS_ODEDITOR_CSS_CDN_URL,
}

export const DesignSystemTokensLoader: FC<DesignSystemTokensLoaderProps> = ({ children, type }) => {
  const [isTokensLoaded, setIsTokensLoaded] = useState(false)
  const tokenName = TOKEN_MAP[type]

  useEffect(() => {
    const existingLink = document.querySelector(`link[href="${tokenName}"]`)
    if (existingLink) {
      setIsTokensLoaded(true)
      return
    }

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = tokenName

    link.onload = () => {
      setIsTokensLoaded(true)
    }

    link.onerror = () => {
      const message = 'Failed to load odeditor tokens CSS'
      console.error(message)
      errorMonitor.captureMessage(message)
    }

    document.head.appendChild(link)

    return () => {
      const linkToRemove = document.querySelector(`link[href="${tokenName}"]`)
      if (linkToRemove) {
        document.head.removeChild(linkToRemove)
      }
    }
  }, [])

  if (!isTokensLoaded) {
    return null
  }

  return <>{children}</>
}
